import InstancesPage from './InstancesPage'
import './InstancesPage.scss'

export default InstancesPage
